module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    staticClass: "snackbar",
    attrs: {
      "color": _vm.globalSnackColor,
      "timeout": 4000,
      "right": true,
      "top": true,
      "value": _vm.globalSnackDisplay
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.globalSnackMessage) + "\n\t\t")]), _vm._v(" "), _c('v-container', {
    staticClass: "loginScreen",
    attrs: {
      "fluid": "true",
      "grid-list-lg": "",
      "text-xs-center": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.globalApp) + "\n\t\t\t\t"), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0"
  }, [(_vm.isAuto == true) ? _c('center', {
    staticStyle: {
      "margin-top": "-25px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../shared/assets/images/3dloader.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("Sign In")]), _vm._v(" "), (_vm.isAuto == false) ? _c('v-form', {
    staticClass: "pl-4 pr-4 pt-4 pb-4",
    model: {
      value: (_vm.isLoginValid),
      callback: function($$v) {
        _vm.isLoginValid = $$v
      },
      expression: "isLoginValid"
    }
  }, [(!_vm.hasAccountSelect) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Username:")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "customInput",
    attrs: {
      "autocomplete": "off",
      "name": "username",
      "rules": _vm.nameRules,
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.loginUsername),
      callback: function($$v) {
        _vm.loginUsername = $$v
      },
      expression: "loginUsername"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.hasAccountSelect) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Password:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": _vm.showPassword ? 'text' : 'password',
      "autocomplete": "off",
      "id": "password",
      "name": "password",
      "rules": _vm.passwordRules,
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.loginPassword),
      callback: function($$v) {
        _vm.loginPassword = $$v
      },
      expression: "loginPassword"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "-10px",
      "margin-bottom": "10px"
    }
  }, [_c('a', {
    staticStyle: {
      "position": "relative",
      "top": "15px",
      "cursor": "pointer",
      "font-size": "13px",
      "color": "#3A6FF2"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.showPassword ? 'Hide Password' : 'Show Password') + "\n\t\t\t\t\t\t\t\t\t\t")])])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.hasAccountSelect) ? _c('p', [_vm._v("Select the account you want to be logged in to")]) : _vm._e(), _vm._v(" "), (_vm.hasAccountSelect) ? _c('v-select', {
    attrs: {
      "items": _vm.userAccountList,
      "label": "Select Account",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.loginAccount),
      callback: function($$v) {
        _vm.loginAccount = $$v
      },
      expression: "loginAccount"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.hasAccountSelect) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.loginAccount
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncCompleteLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("Select")]) : _vm._e(), _vm._v(" "), (!_vm.sendingLoginAuth && !_vm.hasAccountSelect) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success loginBtn"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncAuthorizeLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("Login")]) : _vm._e(), _vm._v(" "), (_vm.sendingLoginAuth) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasAccountSelect) ? _c('v-btn', {
    staticClass: "text-xs-right fPassButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showForgot()
      }
    }
  }, [_vm._v("Forgot Password")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "versionNumber"
  }, [_vm._v("Version: "), _c('b', [_vm._v("Bolt")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('modal')], 1)
},staticRenderFns: []}